export const logo = "/static/images/branding/logo_black.png";

export const theme = {
  palette: {
    primary: {
      main: '#39bfaf'
    },
    secondary: {
      main: '#7f7f7f'
    }
  }
};

export const keywords = [
  "Science", "Science Stories", "Women in Science", "STEM", "IIIF", "Wikidata",
  "Education", "Wikipedia", "Linked Data", "Linked Open Data", "Biographies",
  "Bibliography", "Researchers", "Scientists", "Museums", "Archive",
  "manuscripts", "libraries", "history", "map", "visualization", "data",
  "black scientists", "physics"
];

export const siteDescription = "Visually Learn About Underrepresented " +
"Scientists and Mathematicians that Have Made a Remarkable "
+ "Impact on STEM Research."
